import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    alertActions,
    coinManagementActions,
    kycVerificationListActions,
} from '../../_actions';

import StatBadge from '../../components/Atoms/State Badge/StatBadge';
import MerchantPending from './Components/MerchantPending';
import MerchantApproved from './Components/MerchantApproved';
import MerchantDecline from './Components/MerchantDecline';
import MoreInfo from './Components/MoreInfo';
import ViewHistoryModal from '../../components/Atoms/popup/ViewHistoryModal';
import { useLocation, useNavigate } from 'react-router';
import VerifyMerchant from './Components/VerifyMerchant';
import Loader from '../../components/Atoms/Loader';
import StatusPopup from '../../components/Atoms/popup/Popup';

const MerchantApps = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const tabParam = queryParams.get('tab');
    const { kyc: { merchantKycList = [], merchantKycListTotal, loading } = {} } = useSelector(state => state);
    const [pageNo, setPageNo] = useState(1)
    const size = 5
    const [isLoading, setIsLoading] = useState(false)
    const [selectedData, setSelectedData] = useState(null);
    const [modalState, setModalState] = useState({
        isPending: false,
        isApprove: false,
        isMoreInfo: false,
        isView: false,
        isVerify: false
    });
    const [value, setValue] = useState('');
    const [count, setCount] = useState(null);
    const [activeTab, setActiveTab] = useState(tabParam || 'pending');

    const updateUrlParams = (tab, page) => {
        const params = new URLSearchParams();
        params.set('tab', tab);

        navigate({
            pathname: location.pathname,
            search: params.toString()
        });
    };
    useEffect(() => {
        updateUrlParams(activeTab);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab]);
    useEffect(() => {
        coinManagementActions.getAmountAndCount({ type: 'MERCHANT_APPS' })
            .then(res => res && setCount(res?.data))
            .catch(console.error);
    }, []);



    const tabConfig = useMemo(() => [
        {
            id: 'pending',
            label: 'Pending',
            count: count?.pending || "0",
            apiStatus: 'pending',
            component: () => (
                <MerchantPending
                    merchantKycList={merchantKycList}
                    value={value}
                    setValue={setValue}
                    isApproveModal={modalState.isApprove}
                    handleAction={handleAction}
                    toggleModal={toggleModal}
                    handleSubmit={handleSubmit}
                    isPendingModal={modalState.isPending}
                    isMoreInfoModal={modalState.isMoreInfo}
                    size={size} pageNo={pageNo} total={merchantKycListTotal} onPageChange={onPageChange}
                    count={count?.pending}

                />
            )
        },
        {
            id: 'approved',
            label: 'Approved',
            count: count?.approved || "0",
            apiStatus: 'approved',
            component: () => <MerchantApproved data={merchantKycList} handleAction={handleAction}
                size={size} pageNo={pageNo} total={merchantKycListTotal} onPageChange={onPageChange} count={count?.approved} />
        },
        {
            id: 'rejected',
            label: 'Declined',
            count: count?.rejected || "0",
            apiStatus: 'rejected',
            component: () => <MerchantDecline data={merchantKycList} handleAction={handleAction}
                size={size} pageNo={pageNo} total={merchantKycListTotal} onPageChange={onPageChange} count={count?.rejected} />
        },
        {
            id: 'more-info',
            label: 'More Info ',
            count: count?.moreInfo || "0",
            apiStatus: 'more-info',
            component: () => <MoreInfo data={merchantKycList} handleAction={handleAction}
                size={size} pageNo={pageNo} total={merchantKycListTotal} onPageChange={onPageChange} count={count?.moreInfo} />
        },
        {
            id: 'verified-merchant',
            label: 'Verified ',
            count: count?.verified || "0",
            apiStatus: 'verified-merchant',
            component: () => <VerifyMerchant data={merchantKycList} handleAction={handleAction}
                size={size} pageNo={pageNo} total={merchantKycListTotal} onPageChange={onPageChange} count={count?.verified} />
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
    ], [merchantKycList, count, value, modalState,]);

    const currentTab = tabConfig.find(tab => tab.id === activeTab) || tabConfig[0];

    const fetchKycList = () => {
        dispatch(kycVerificationListActions.merchantKycList({
            keyWord: '',
            pageNo: pageNo,
            size: size,
            status: currentTab.apiStatus
        }));
    };

    useEffect(() => {
        fetchKycList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab, pageNo, size]);

    const handleTabChange = tabId => {
        setActiveTab(tabId);
        setPageNo(1);
    };

    const handleAction = (action, data) => {
        setSelectedData(data);
        const newState = {
            isPending: false,
            isApprove: false,
            isMoreInfo: false,
            isView: false,
            isVerify: false
        };

        switch (action) {
            case 'PENDING':
                newState.isPending = true;
                break;
            case 'APPROVE':
                newState.isApprove = true;
                break;
            case 'VERIFY':
                newState.isVerify = true;
                break;
            case 'MORE_INFO':
                newState.isMoreInfo = true;
                break;
            case 'VIEW':
                newState.isView = true;
                setIsLoading(true)
                kycVerificationListActions.viewRejectionsReasonsForMerchantKyc({ id: data?._id })
                    .then(res => res && setSelectedData(res.data))
                    .catch(console.error).finally(() => {
                        setIsLoading(false)
                    });
                break;
            default:
                break;
        }
        setModalState(newState);
    };

    const toggleModal = (action) => {
        const newState = { ...modalState };
        // eslint-disable-next-line default-case
        switch (action) {
            case 'PENDING':
                newState.isPending = false;
                break;
            case 'APPROVE':
                newState.isApprove = false;
                break;
            case 'MORE_INFO':
                newState.isMoreInfo = false;
                break;
            case 'VERIFY':
                newState.isVerify = false;
                break;
            case 'VIEW':
                newState.isView = false;
                break;
        }
        setModalState(newState);
        setSelectedData(null);
        setValue('');
    };

    const handleSubmit = async (e, action) => {
        e?.preventDefault?.();
        const payload = {
            id: selectedData?._id,
            status: '',
            ...(value && { reason: value })
        };

        if (action === 'Pending') payload.status = 'rejected';
        if (action === 'Approve') payload.status = 'approved';
        if (action === 'More-Info') payload.status = 'more-info';

        try {
            setIsLoading(true);
            const res = await kycVerificationListActions.approveOrRejectMerchantKyc(payload);
            if (res) {
                const msg = res?.data?.message || res?.message || "Merchant status updated successfully";
                dispatch(alertActions.success(msg));
                coinManagementActions.getAmountAndCount({ type: 'MERCHANT_APPS' })
                    .then(res => res && setCount(res?.data))
                    .catch(console.error);
                fetchKycList();
                setValue('');
                setModalState({ isPending: false, isApprove: false, isMoreInfo: false, isView: false, isVerify: false });
                setSelectedData(null);
            }
        } catch (error) {
            console.error(error);
            dispatch(alertActions.error(error?.message || error || "Failed to update merchant status"));
            setValue('');
            setModalState({ isPending: false, isApprove: false, isMoreInfo: false, isView: false, isVerify: false });
            setSelectedData(null);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSubMerchantNavigate = () => {
        navigate(`/app/merchant-apps/sub-merchants`)
    }

    const onPageChange = pageNo => {
        setPageNo(pageNo)
    }

    const handleSubmitVerify = () => {
        setIsLoading(true)
        kycVerificationListActions.convertToVerifiedMerchant({
            "id": selectedData?._id,
            "isStore": false
        }).then((res) => {
            if (res) {
                dispatch(alertActions.success(res?.message));
                coinManagementActions.getAmountAndCount({ type: 'MERCHANT_APPS' })
                    .then(res => res && setCount(res?.data))
                    .catch(console.error);
                fetchKycList();
                setModalState({ isPending: false, isApprove: false, isMoreInfo: false, isView: false, isVerify: false });
                setSelectedData(null);
                setIsLoading(false)
            }
        }).catch((error) => {
            dispatch(alertActions.error(error))
        }).finally(() => {
            setIsLoading(false)
        })
    }

    return (
        <div className="p-4 overflow-auto">
            <Loader loading={loading || isLoading} />
            <div className="p-3">
                <div className="flex flex-col gap-4 md:flex-row md:justify-between md:items-center">
                    <h1 className="text-xl font-bold text-gray-800">Merchant Apps</h1>

                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 w-full md:w-auto">
                        {/* Stats */}
                        <div className="grid lg:grid-cols-5 md:grid-cols-3 grid-cols-1 gap-2 justify-center sm:justify-start">
                            {tabConfig.map(tab => (
                                <StatBadge
                                    key={tab.id}
                                    label={`${tab.label} : ${tab.count}`}
                                    isActive={activeTab === tab.id}
                                    onClick={() => { handleTabChange(tab.id); setPageNo(1) }}
                                />
                            ))}
                        </div>

                        {/* Button */}
                        <div className="flex  justify-center sm:justify-end">
                            <button
                                className="bg-[#00811D] text-white rounded-[8px] px-4 py-2 w-full sm:w-auto"
                                onClick={handleSubMerchantNavigate}
                            >
                                Sub Merchant
                            </button>
                        </div>
                    </div>
                </div>
            </div>


            <div className="p-3">{currentTab.component()}</div>

            <ViewHistoryModal
                isOpen={modalState.isView}
                onClose={() => toggleModal('VIEW')}
                data={selectedData}
                heading="History"
                isLoading={isLoading}
                isNotesData={false}
                isApiResData={true}
            />
            <StatusPopup isOpen={modalState.isVerify} onClose={() => toggleModal('VERIFY')} heading={`Are You Sure Want To Verify !`} onConfirm={handleSubmitVerify} />
        </div>
    );
};

export default MerchantApps;
